import { EventRegistry } from '../../../../../domain/event/event.registry';
import { FieldEvent } from './field.event';
export class FieldCreatedEvent extends FieldEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `field/${payload.id}`,
            type: FieldCreatedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
FieldCreatedEvent.type = 'com.treeplotter.api.field.created.v1';
EventRegistry.register(FieldCreatedEvent.type, FieldCreatedEvent);
//# sourceMappingURL=field-created.event.js.map